import React, { useEffect, useState, forwardRef } from 'react';

import QRCode from "qrcode.react";

import {
    useScanData
} from "../../hooks/useScanData"

export default function DocumentQrCode({
    data,
    outputType,
    scopeType,
    targetType
}) {

    const { getScanData } = useScanData(
        outputType,
        scopeType,
        targetType
    )

    const RenderQRCodeHidden = ({ data }) => {

        if (!data) return <></>

        const {
            document
        } = data

        // use the function to get the code data
        let dataQrcode = getScanData({
            id: document?.id,
            data
        })

        try {

            return (
                <>
                    <div
                        style={{
                            float: 'left',
                            display: 'none'
                        }}
                    >
                        <div>
                            <QRCode
                                id={`qrcodeImg`}
                                value={dataQrcode}
                                size={128}
                                bgColor={`#ffffff`}
                                fgColor={`#000000`}
                                level={`H`}
                                includeMargin={Boolean(true)}
                            />
                        </div>
                    </div>
                </>
            )

        } catch (error) {
            // promptMessage(false, `Error occured during scan code generation`)
            console.error(`Error : ${error}`)
        }

        return false

    }

    return (
        <RenderQRCodeHidden
            data={data}
        />
    )

}